export default {

    parentCategory: {
        method: "POST",
        url: "/sortingCityAdmin/front-end/back-cate-list",
        name: "分拣中心大类"
    },
    brokeCategory: {
        method: "POST",
        url: "/common/sorting/broke-category",
        name: "分拣中心小类"
    },
};